import { Code, createTheme, type MantineTheme } from '@mantine/core';
import type { PartialDeep } from 'type-fest';

export const ThemedMantineCode: PartialDeep<MantineTheme> = createTheme({
  components: {
    Code: Code.extend({
      styles: theme => ({
        root: {
          border: `1px solid ${theme.colors.purple[3]}`,
          backgroundColor: theme.colors.purple[1],
          color: theme.colors.purple[6],
        },
      }),
    }),
  },
});
